export default "__VITE_ASSET__COXT9P$X__"